module.exports = __webpack_public_path__ + "static/quskr-467131558bdd668b854733a1815a04c0.png";